import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const LINKS = [
  { to: "/integritetspolicy", label: "Integritetspolicy" },
  { to: "/anvandarvillkor", label: "Användarvillkor" },
  { to: "/kopvillkor", label: "Köpvillkor" },
  { to: "/cookies", label: "Cookies" },
  { to: "/kontakt", label: "Kontakt" },
];

export const CONTACT_EMAIL = "spontanai.info@gmail.com";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 bg-white"
    >
      <div className="mx-auto w-full max-w-5xl px-4 py-10 sm:px-6">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <Link
              to="/"
              data-testid="footer-logo"
              className="font-display text-xl font-extrabold tracking-tight text-slate-900"
            >
              Spontan<span className="text-emerald-600">.</span>
            </Link>
            <p className="mt-2 max-w-xs text-sm text-slate-500">
              Hitta jobb där annonserna inte finns – och skicka en spontanansökan direkt.
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email"
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700 hover:text-emerald-800"
            >
              <Mail className="h-4 w-4" /> {CONTACT_EMAIL}
            </a>
          </div>

          <nav className="grid grid-cols-2 gap-x-8 gap-y-2 sm:text-right">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.to.replace("/", "")}`}
                className="text-sm text-slate-600 transition-colors hover:text-emerald-700"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-8 border-t border-slate-100 pt-6 text-xs text-slate-400">
          © {new Date().getFullYear()} Spontan. Alla rättigheter förbehållna.
        </div>
      </div>
    </footer>
  );
}
